var _style, _defs, _rect, _defs2, _rect2, _path, _feBlend, _defs3, _defs4, _defs5, _rect3, _defs6, _defs7, _rect4, _feBlend2, _defs8, _defs9, _defs10, _rect5, _defs11, _path2, _path3, _defs12, _rect6, _defs13, _rect7, _feBlend3, _defs14, _defs15, _defs16, _rect8, _defs17, _path4, _path5, _path6, _feBlend4, _defs18, _defs19, _defs20, _rect9, _defs21, _defs22, _rect10, _feBlend5, _defs23, _defs24, _defs25, _rect11, _defs26, _path7, _path8, _path9, _defs27, _rect12, _path10, _feBlend6, _defs28, _defs29, _defs30, _polygon, _defs31, _defs32, _rect13, _defs33, _rect14, _path11, _defs34, _polygon2, _defs35, _rect15, _feBlend7, _defs36, _defs37, _defs38, _rect16, _defs39, _defs40, _polygon3, _path12, _path13, _path14, _path15, _path16, _path17, _defs41, _rect17, _feBlend8, _defs42, _defs43, _defs44, _rect18, _defs45, _path18, _path19, _defs46, _polygon4, _defs47, _polygon5, _feBlend9, _defs48, _defs49, _defs50, _rect19, _defs51, _defs52, _rect20, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgW1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53.9 51.3",
    style: {
      enableBackground: "new 0 0 53.9 51.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:url(#SVGID_3_);}\r\n\t.st2{clip-path:url(#SVGID_5_);}\r\n\t.st3{fill:url(#SVGID_6_);}\r\n\t.st4{fill:#005999;}\r\n\t.st5{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st6{enable-background:new    ;}\r\n\t.st7{clip-path:url(#SVGID_9_);}\r\n\t.st8{clip-path:url(#SVGID_11_);}\r\n\t.st9{clip-path:url(#SVGID_13_);fill:url(#SVGID_14_);}\r\n\t.st10{mask:url(#SVGID_7_);}\r\n\t.st11{clip-path:url(#SVGID_16_);}\r\n\t.st12{clip-path:url(#SVGID_18_);}\r\n\t.st13{fill:url(#SVGID_19_);}\r\n\t.st14{filter:url(#Adobe_OpacityMaskFilter_1_);}\r\n\t.st15{clip-path:url(#SVGID_22_);}\r\n\t.st16{clip-path:url(#SVGID_24_);}\r\n\t.st17{clip-path:url(#SVGID_26_);fill:url(#SVGID_27_);}\r\n\t.st18{mask:url(#SVGID_20_);}\r\n\t.st19{clip-path:url(#SVGID_29_);fill:#0091BE;}\r\n\t.st20{fill:#006CB6;}\r\n\t.st21{clip-path:url(#SVGID_31_);}\r\n\t.st22{fill:url(#SVGID_32_);}\r\n\t.st23{clip-path:url(#SVGID_34_);}\r\n\t.st24{fill:url(#SVGID_35_);}\r\n\t.st25{filter:url(#Adobe_OpacityMaskFilter_2_);}\r\n\t.st26{clip-path:url(#SVGID_38_);}\r\n\t.st27{clip-path:url(#SVGID_40_);}\r\n\t.st28{clip-path:url(#SVGID_42_);fill:url(#SVGID_43_);}\r\n\t.st29{mask:url(#SVGID_36_);}\r\n\t.st30{clip-path:url(#SVGID_45_);fill:#00B8F1;}\r\n\t.st31{fill:#0078AE;}\r\n\t.st32{fill:#005E9C;}\r\n\t.st33{filter:url(#Adobe_OpacityMaskFilter_3_);}\r\n\t.st34{clip-path:url(#SVGID_48_);}\r\n\t.st35{clip-path:url(#SVGID_50_);}\r\n\t.st36{clip-path:url(#SVGID_52_);fill:url(#SVGID_53_);}\r\n\t.st37{mask:url(#SVGID_46_);}\r\n\t.st38{clip-path:url(#SVGID_55_);}\r\n\t.st39{clip-path:url(#SVGID_57_);}\r\n\t.st40{fill:url(#SVGID_58_);}\r\n\t.st41{filter:url(#Adobe_OpacityMaskFilter_4_);}\r\n\t.st42{clip-path:url(#SVGID_61_);}\r\n\t.st43{clip-path:url(#SVGID_63_);}\r\n\t.st44{clip-path:url(#SVGID_65_);fill:url(#SVGID_66_);}\r\n\t.st45{mask:url(#SVGID_59_);}\r\n\t.st46{clip-path:url(#SVGID_68_);fill:#00A0E3;}\r\n\t.st47{fill:#0082C5;}\r\n\t.st48{clip-path:url(#SVGID_70_);}\r\n\t.st49{fill:url(#SVGID_71_);}\r\n\t.st50{fill:#007DC4;}\r\n\t.st51{filter:url(#Adobe_OpacityMaskFilter_5_);}\r\n\t.st52{clip-path:url(#SVGID_74_);}\r\n\t.st53{clip-path:url(#SVGID_76_);}\r\n\t.st54{clip-path:url(#SVGID_78_);fill:url(#SVGID_79_);}\r\n\t.st55{mask:url(#SVGID_72_);}\r\n\t.st56{clip-path:url(#SVGID_81_);}\r\n\t.st57{clip-path:url(#SVGID_83_);}\r\n\t.st58{fill:url(#SVGID_84_);}\r\n\t.st59{clip-path:url(#SVGID_86_);}\r\n\t.st60{fill:url(#SVGID_87_);}\r\n\t.st61{fill:#00A0E3;}\r\n\t.st62{clip-path:url(#SVGID_89_);}\r\n\t.st63{fill:url(#SVGID_90_);}\r\n\t.st64{clip-path:url(#SVGID_92_);}\r\n\t.st65{fill:url(#SVGID_93_);}\r\n\t.st66{filter:url(#Adobe_OpacityMaskFilter_6_);}\r\n\t.st67{clip-path:url(#SVGID_96_);}\r\n\t.st68{clip-path:url(#SVGID_98_);}\r\n\t.st69{clip-path:url(#SVGID_100_);fill:url(#SVGID_101_);}\r\n\t.st70{mask:url(#SVGID_94_);}\r\n\t.st71{clip-path:url(#SVGID_103_);}\r\n\t.st72{clip-path:url(#SVGID_105_);}\r\n\t.st73{fill:url(#SVGID_106_);}\r\n\t.st74{fill:#009ADE;}\r\n\t.st75{fill:#0060AE;}\r\n\t.st76{fill:#0064B0;}\r\n\t.st77{fill:#0062A7;}\r\n\t.st78{clip-path:url(#SVGID_108_);}\r\n\t.st79{fill:url(#SVGID_109_);}\r\n\t.st80{filter:url(#Adobe_OpacityMaskFilter_7_);}\r\n\t.st81{clip-path:url(#SVGID_112_);}\r\n\t.st82{clip-path:url(#SVGID_114_);}\r\n\t.st83{clip-path:url(#SVGID_116_);fill:url(#SVGID_117_);}\r\n\t.st84{mask:url(#SVGID_110_);}\r\n\t.st85{clip-path:url(#SVGID_119_);fill:#6DC3E8;}\r\n\t.st86{clip-path:url(#SVGID_119_);fill:#37BDE9;}\r\n\t.st87{clip-path:url(#SVGID_119_);}\r\n\t.st88{clip-path:url(#SVGID_121_);}\r\n\t.st89{fill:url(#SVGID_122_);}\r\n\t.st90{clip-path:url(#SVGID_124_);}\r\n\t.st91{fill:url(#SVGID_125_);}\r\n\t.st92{filter:url(#Adobe_OpacityMaskFilter_8_);}\r\n\t.st93{clip-path:url(#SVGID_128_);}\r\n\t.st94{clip-path:url(#SVGID_130_);}\r\n\t.st95{clip-path:url(#SVGID_132_);fill:url(#SVGID_133_);}\r\n\t.st96{mask:url(#SVGID_126_);}\r\n\t.st97{clip-path:url(#SVGID_135_);}\r\n\t.st98{clip-path:url(#SVGID_137_);}\r\n\t.st99{fill:url(#SVGID_138_);}\r\n\t.st100{fill:#231F20;}\r\n\t.st101{fill-rule:evenodd;clip-rule:evenodd;fill:#EC2024;}\r\n\t.st102{fill-rule:evenodd;clip-rule:evenodd;fill:#008AC7;}\r\n\t.st103{fill:#E92D2F;stroke:#E92D2F;stroke-width:9.375000e-02;stroke-miterlimit:10;}\r\n\t.st104{fill:#0774BA;stroke:#0774BA;stroke-width:9.375000e-02;stroke-miterlimit:10;}\r\n\t.st105{clip-path:url(#SVGID_140_);}\r\n\t.st106{fill-rule:evenodd;clip-rule:evenodd;fill:#6481B9;}\r\n\t.st107{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st108{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\r\n\t.st109{fill:url(#SVGID_145_);}\r\n\t.st110{fill:url(#SVGID_146_);}\r\n\t.st111{fill:#539E43;}\r\n\t.st112{fill:#333333;}\r\n\t.st113{fill:url(#path-2_2_);}\r\n\t.st114{filter:url(#Adobe_OpacityMaskFilter_9_);}\r\n\t.st115{fill:#FFFFFF;}\r\n\t.st116{mask:url(#mask-3_4_);}\r\n\t.st117{fill:none;}\r\n\t.st118{fill:url(#SVGID_147_);}\r\n\t.st119{filter:url(#Adobe_OpacityMaskFilter_10_);}\r\n\t.st120{mask:url(#mask-3_3_);}\r\n\t.st121{fill:url(#SVGID_148_);}\r\n\t.st122{fill:url(#SVGID_149_);}\r\n\t.st123{fill:url(#SVGID_150_);}\r\n\t.st124{fill:url(#SVGID_151_);}\r\n\t.st125{fill:url(#SVGID_152_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M18.7,4.4c1.9,5.9,2.7,16.5,8.3,16.5l0,0c0.4,0,0.9,0,1.3-0.1l0,0c-5.1-1.2-5.8-11.6-8.9-17.1l0,0 C19.2,3.9,18.9,4.1,18.7,4.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 25.6288 25.6288 0 -1334.196 0.3777)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0095DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1099,
    style: {
      stopColor: "#0095DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1755,
    style: {
      stopColor: "#0397DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    style: {
      stopColor: "#0E9FDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2812,
    style: {
      stopColor: "#1FACE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    style: {
      stopColor: "#37BEF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#44C8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#44C8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4666,
    style: {
      stopColor: "#40C4F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    style: {
      stopColor: "#1D9DDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    style: {
      stopColor: "#0886CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#007DC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007DC5"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -48.5,
    y: 3.7,
    className: "st1",
    width: 76.9,
    height: 76.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M19.4,3.7c3.1,5.4,3.8,15.9,8.9,17.1l0,0c0.4-0.1,0.8-0.2,1.2-0.3l0,0C24.9,18.1,23.7,8,20.1,3.1l0,0 C19.9,3.3,19.7,3.5,19.4,3.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 26.2819 26.2819 0 -1368.0016 -0.3845)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0078B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    style: {
      stopColor: "#0078B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2436,
    style: {
      stopColor: "#0087C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#00ABE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#00ABE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7321,
    style: {
      stopColor: "#00ACE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#00AEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEEF"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -49.4,
    y: 3.1,
    className: "st3",
    width: 78.8,
    height: 78.8
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24,0.5c-0.4,0-0.9,0-1.3,0.1c-1.1,0.2-2.3,0.7-3.5,1.5c0.3,0.3,0.6,0.7,0.9,1.1c1.2-1,2.4-1.7,3.6-2.2 c0.4-0.2,0.9-0.3,1.3-0.4C24.7,0.5,24.3,0.5,24,0.5"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 25,
    y: 0.5,
    width: 9.6,
    height: 17.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0.5,
    width: 9.6,
    height: 17.9,
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_8_",
    x: 9.3,
    y: -0.1,
    width: 30,
    height: 10.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_10_",
    x: 9.3,
    y: -0.1,
    width: 30,
    height: 10.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_12_",
    x: 9.3,
    y: -0.1,
    width: 30,
    height: 10.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_",
    className: "st8"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 10.5272 10.5272 0 -533.4497 -7.405599e-02)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1531,
    style: {
      stopColor: "#464344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#CAC9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: -0.1,
    className: "st9",
    width: 31.6,
    height: 31.6
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 25,
    y: 0.5,
    width: 9.6,
    height: 17.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M33.2,18.3c0.5-0.4,0.9-0.8,1.4-1.2c-2-5.9-2.7-16.6-8.4-16.6c-0.4,0-0.8,0-1.2,0.1 C30.2,1.9,30.8,13.2,33.2,18.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -20.9121 -20.9121 0 1137.7072 20.2978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0066B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    style: {
      stopColor: "#0079C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    style: {
      stopColor: "#00A9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#00B9F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B9F2"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: -44.4,
    className: "st13",
    width: 62.7,
    height: 62.7
  })))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 24,
    y: 0.5,
    width: 2.2,
    height: 0.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 0.5,
    width: 2.2,
    height: 0.1,
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 9.3,
    y: -0.1,
    width: 30,
    height: 10.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 9.3,
    y: -0.1,
    width: 30,
    height: 10.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_",
    className: "st15"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 9.3,
    y: -0.1,
    width: 30,
    height: 10.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_",
    className: "st16"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 10.5272 10.5272 0 -533.4497 -7.405599e-02)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1531,
    style: {
      stopColor: "#464344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#CAC9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: -0.1,
    className: "st17",
    width: 31.6,
    height: 31.6
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_28_",
    x: 24,
    y: 0.5,
    width: 2.2,
    height: 0.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M25,0.6c-0.3-0.1-0.7-0.1-1-0.1l2.2,0C25.8,0.5,25.4,0.5,25,0.6"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M33.1,19.6c-0.2-0.2-0.4-0.4-0.6-0.7c-1,0.7-1.9,1.2-2.9,1.5c0.3,0.2,0.7,0.3,1.1,0.4 c0.3,0.1,0.6,0.1,0.9,0.1c1.1,0,1.9-0.1,2.6-0.5C33.8,20.2,33.4,19.9,33.1,19.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_30_",
    d: "M23.6,0.9c4.7,2.4,5.1,13.5,8.8,17.9l0,0c0.2-0.2,0.5-0.4,0.7-0.6l0,0c-2.3-5.1-3-16.4-8.2-17.7l0,0 C24.5,0.7,24.1,0.8,23.6,0.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_31_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_30_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 27.2874 27.2874 0 -1417.1803 -2.9157)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006CB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989075,
    style: {
      stopColor: "#006CB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2001,
    style: {
      stopColor: "#007EC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#00ABE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5165,
    style: {
      stopColor: "#00ABE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#0097D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0097D9"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -48.6,
    y: 0.7,
    className: "st22",
    width: 81.9,
    height: 81.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M20.1,3.1c3.6,4.9,4.8,15,9.5,17.3l0,0c0.9-0.3,1.9-0.8,2.9-1.5l0,0c-3.7-4.5-4.1-15.5-8.8-17.9l0,0 C22.5,1.4,21.3,2.1,20.1,3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 29.0166 29.0166 0 -1510.9567 -2.7994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00487E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1099,
    style: {
      stopColor: "#00487E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#0087C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#0087C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    style: {
      stopColor: "#0082C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7802,
    style: {
      stopColor: "#005598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005598"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 1,
    className: "st24",
    width: 12.3,
    height: 19.5
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 14.6,
    y: 2.8,
    width: 4.1,
    height: 6.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 14.6,
    y: 2.8,
    width: 4.1,
    height: 6.5,
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: -2.2,
    y: -0.7,
    width: 30,
    height: 25.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: -2.2,
    y: -0.7,
    width: 30,
    height: 25.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_",
    className: "st26"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: -2.2,
    y: -0.7,
    width: 30,
    height: 25.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_",
    className: "st27"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -25.5425 -25.5425 0 1366.0665 24.8249)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    style: {
      stopColor: "#464344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8611,
    style: {
      stopColor: "#CAC9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -2.2,
    y: -0.7,
    className: "st28",
    width: 30,
    height: 25.5
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_44_",
    x: 14.6,
    y: 2.8,
    width: 4.1,
    height: 6.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_45_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_44_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M16.4,4.2c-0.6,1.3-1.1,2.9-1.8,5.1c1.4-1.9,2.7-3.6,4.1-5c-0.2-0.6-0.4-1.1-0.6-1.6 C17.5,3.2,17,3.7,16.4,4.2"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M18.6,2.4c-0.2,0.1-0.3,0.2-0.5,0.4c0.2,0.5,0.4,1,0.6,1.6c0.2-0.2,0.5-0.5,0.7-0.7 C19.2,3.2,18.9,2.8,18.6,2.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M19.2,2c-0.2,0.1-0.4,0.3-0.6,0.4c0.3,0.4,0.6,0.8,0.8,1.2c0.2-0.2,0.4-0.4,0.6-0.6 C19.8,2.7,19.5,2.3,19.2,2"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 37,
    y: 0,
    width: 16.7,
    height: 20.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 0,
    width: 16.7,
    height: 20.9,
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: 30.6,
    y: -0.4,
    width: 30,
    height: 18.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: 30.6,
    y: -0.4,
    width: 30,
    height: 18.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_",
    className: "st34"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_51_",
    x: 30.6,
    y: -0.4,
    width: 30,
    height: 18.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_",
    className: "st35"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 18.3374 18.3374 0 -926.0079 -0.5081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333132"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7308,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: -0.5,
    className: "st36",
    width: 55,
    height: 55
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_54_",
    x: 37,
    width: 16.7,
    height: 20.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_55_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_54_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_56_",
    d: "M50.9,0c-2.6,10.1-8.1,18.3-12.7,20.4c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.2,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0 c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0 c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0.2,0.1,0.4,0.1,0.7,0.1c4.4,0,8.8-7.8,16.1-20.8H50.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_57_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_56_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -20.3713 -20.3713 0 1124.6704 19.7517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    style: {
      stopColor: "#0A87C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3268,
    style: {
      stopColor: "#16A8DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4906,
    style: {
      stopColor: "#1DBDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#20C4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20C4F4"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1,
    y: -40.2,
    className: "st40",
    width: 61.1,
    height: 61.1
  })))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0.5,
    width: 15.2,
    height: 20.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.5,
    width: 15.2,
    height: 20.9,
    id: "SVGID_59_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_60_",
    x: -9.3,
    y: -1.7,
    width: 30,
    height: 25.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_61_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_60_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_62_",
    x: -9.3,
    y: -1.7,
    width: 30,
    height: 25.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_63_",
    className: "st42"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_62_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_64_",
    x: -9.3,
    y: -1.7,
    width: 30,
    height: 25.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_65_",
    className: "st43"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_64_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -25.5408 -25.5408 0 1358.9778 23.9128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1531,
    style: {
      stopColor: "#464344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#CAC9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -9.2,
    y: -1.6,
    className: "st44",
    width: 30,
    height: 25.5
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_67_",
    x: 0,
    y: 0.5,
    width: 15.2,
    height: 20.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M13.6,0.9C13.6,0.9,13.7,0.9,13.6,0.9C13.7,0.9,13.7,0.9,13.6,0.9C13.7,0.9,13.7,0.9,13.6,0.9 C13.7,0.8,13.7,0.8,13.6,0.9c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2-0.1c0,0,0,0,0,0 c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0.1,0,0.2,0,0.2-0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0 c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0c-0.2,0-0.3,0-0.5,0C9.9,0.5,3.1,9.6,0,21.4c0,0,0.2,0,0.6,0c1-1.7,1.9-3.4,2.7-4.9C5.4,8.1,9.8,2.4,13.6,0.9 "
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M16.4,4.2c0.6-0.5,1.1-1,1.7-1.4C18,2.5,17.8,2.3,17.7,2C17.2,2.6,16.8,3.3,16.4,4.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M16.8,0.9c0.3,0.3,0.6,0.6,0.9,1.1c0.1-0.1,0.2-0.2,0.3-0.3C17.6,1.4,17.2,1.1,16.8,0.9 C16.8,0.9,16.8,0.9,16.8,0.9C16.8,0.9,16.8,0.9,16.8,0.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_69_",
    d: "M3.3,16.5C7.8,7.8,9.9,2.3,13.6,0.9l0,0C9.8,2.4,5.4,8.1,3.3,16.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st48"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -20.8586 -20.8586 0 1113.4376 20.1936)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008FD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5364,
    style: {
      stopColor: "#009DDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A4E0"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: -46.2,
    className: "st49",
    width: 62.6,
    height: 62.6
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M17.9,1.7c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0.2,0.3,0.5,0.4,0.8c0.2-0.1,0.3-0.2,0.5-0.4 C18.4,2.2,18.2,1.9,17.9,1.7"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 5,
    y: 9.3,
    width: 9.7,
    height: 12.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 9.3,
    width: 9.7,
    height: 12.1,
    id: "SVGID_72_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st51"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_73_",
    x: -5.1,
    y: 2.3,
    width: 22.7,
    height: 26.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_73_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_75_",
    x: -5.1,
    y: 2.3,
    width: 22.7,
    height: 26.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_76_",
    className: "st52"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_75_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_77_",
    points: "-5.1,23 5.7,29 17.6,8.4 6.7,2.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_",
    className: "st53"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_77_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(-19.5333 34.9287 34.9287 19.5333 -1839.3774 -1027.5358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02471732,
    style: {
      stopColor: "#4C494A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05426459,
    style: {
      stopColor: "#767374"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08626083,
    style: {
      stopColor: "#9B9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1204,
    style: {
      stopColor: "#BAB9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1572,
    style: {
      stopColor: "#D3D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1977,
    style: {
      stopColor: "#E7E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    style: {
      stopColor: "#F5F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3009,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "29.1,8.9 -29.5,113.7 -134.3,55.1 -75.7,-49.7  "
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st55"
  }, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_80_",
    x: 5,
    y: 9.3,
    width: 9.6,
    height: 12.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_81_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_80_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st56"
  }, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_82_",
    d: "M5.3,21.4L5.3,21.4C5.3,21.4,5.3,21.4,5.3,21.4C5.2,21.4,5.2,21.4,5.3,21.4c-0.1,0-0.1,0-0.2,0 c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0h0c4.5-0.1,6.6-2.4,7.6-5.7c0.8-2.5,1.4-4.6,2-6.4c-1.9,2.7-3.8,5.9-5.7,9.4 C7.9,20.5,6.5,21.2,5.3,21.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_83_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_82_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st57"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -20.2757 -20.2757 0 1083.9951 20.3348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A1E4"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -39.4,
    className: "st58",
    width: 60.8,
    height: 60.8
  })))))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_85_",
    d: "M5.3,21.4L5.3,21.4c1.2-0.2,2.6-0.9,3.5-2.6l0,0c1.9-3.6,3.8-6.8,5.7-9.4l0,0c0.7-2.2,1.3-3.8,1.8-5.1 l0,0C12.6,7.8,8.8,13.8,5.3,21.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st59"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -17.1333 -17.1333 0 918.4544 21.255)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005DA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1538,
    style: {
      stopColor: "#005DA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3179,
    style: {
      stopColor: "#007BC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#00A1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5685,
    style: {
      stopColor: "#05A2E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    style: {
      stopColor: "#14A6E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7403,
    style: {
      stopColor: "#2CACE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8343,
    style: {
      stopColor: "#4EB5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9176,
    style: {
      stopColor: "#72BEE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72BEE4"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 4.1,
    className: "st60",
    width: 11.1,
    height: 17.1
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M3.3,16.5c-0.8,1.5-1.7,3.2-2.7,4.9c0.4,0,1,0,1.7,0C2.6,19.7,2.9,18,3.3,16.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_88_",
    d: "M15.1,0.5C15.1,0.5,15.1,0.5,15.1,0.5L15.1,0.5C15,0.5,15,0.5,15.1,0.5L15.1,0.5c-0.1,0-0.1,0-0.1,0l0,0 c0,0,0,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0-0.1,0l0,0 c0,0,0,0,0,0l0,0c-0.1,0-0.2,0-0.2,0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0-0.1,0l0,0c0,0,0,0,0,0 l0,0c-0.1,0-0.1,0-0.2,0.1l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0-0.1,0l0,0c0,0,0,0,0,0l0,0 c-3.8,1.5-5.9,7-10.4,15.6l0,0c-0.4,1.6-0.7,3.2-0.9,4.9l0,0h0.2c0.7,0,0.9,0,1.6,0l0,0h0h0.1h0h0h0h0h0h0h0.1h0.1h0.1h0 c0,0,0.1,0,0.1,0l0,0c0.1,0,0.1,0,0.2,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0,0l0,0c0,0,0.1,0,0.1,0l0,0v0 c3.5-7.5,7.3-13.5,11.1-17.1l0,0c0.4-0.9,0.8-1.7,1.3-2.2l0,0c-0.3-0.4-0.6-0.8-0.9-1.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0-0.1,0l0,0 c0,0,0,0-0.1,0l0,0c0,0,0,0-0.1,0l0,0c0,0,0,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0 l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0 c0,0,0,0,0,0l0,0c-0.1,0-0.2,0-0.2-0.1l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0 c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0l0,0C15.2,0.5,15.1,0.5,15.1,0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_89_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_88_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st62"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(-3.2757 -18.5773 -18.5773 3.2757 995.4788 -153.289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005496"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1044,
    style: {
      stopColor: "#005496"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0083C5"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "2.5,24 -7.3,-31.7 48.4,-41.5 58.3,14.2  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_91_",
    d: "M40.6,5.6c-0.9,2.8-1.6,5-2.2,6.9l0,0c2.4-3.3,4.7-7.4,6.9-12.1l0,0C42.8,1.3,41.4,3.1,40.6,5.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_92_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_91_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st64"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -9.7084 -9.7084 0 556.1847 9.6933)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4655,
    style: {
      stopColor: "#009FE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#0098D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    style: {
      stopColor: "#0095D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0095D4"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: -16.6,
    className: "st65",
    width: 29.1,
    height: 29.1
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_6_",
    filterUnits: "userSpaceOnUse",
    x: 34.8,
    y: -2,
    width: 19.7,
    height: 24.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend7 || (_feBlend7 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 34.8,
    y: -2,
    width: 19.7,
    height: 24.7,
    id: "SVGID_94_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st66"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_95_",
    x: 31.4,
    y: -1.8,
    width: 30,
    height: 10.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_96_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_95_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_97_",
    x: 31.4,
    y: -1.8,
    width: 30,
    height: 10.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_98_",
    className: "st67"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_97_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_99_",
    x: 31.4,
    y: -1.8,
    width: 30,
    height: 10.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_100_",
    className: "st68"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_99_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 10.4614 10.4614 0 -507.7992 -1.7728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1531,
    style: {
      stopColor: "#464344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#CAC9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1,
    y: -1.8,
    className: "st69",
    width: 31.4,
    height: 31.4
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st70"
  }, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_102_",
    x: 38.2,
    width: 12.7,
    height: 20.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_103_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_102_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st71"
  }, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_104_",
    d: "M38.5,20.2c-0.1,0.1-0.2,0.1-0.4,0.2C42.8,18.3,48.3,10.1,50.9,0h-0.5C44.3,10.8,42.4,18,38.5,20.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_105_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_104_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st72"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(-3.9474 22.387 22.387 3.9474 -1139.5039 -209.7907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A4E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3571,
    style: {
      stopColor: "#00A4E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#0089CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0089CF"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "54.4,0.8 42.6,68 -24.6,56.1 -12.7,-11  "
  })))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M35.5,19.3c1-1.2,1.8-3.3,2.9-6.7c-1.3,1.8-2.6,3.3-3.9,4.5c0,0,0,0,0,0C34.9,17.9,35.2,18.7,35.5,19.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M35.5,19.3c-0.3,0.4-0.7,0.7-1.1,1c-0.1,0.1-0.2,0.1-0.3,0.1c0.4,0.2,0.9,0.4,1.4,0.4h0h0c0.1,0,0.2,0,0.2,0 h0c0,0,0.1,0,0.1,0h0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0h0c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0C36.5,20.5,36,20,35.5,19.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M27,20.9c0.4,0,0.9,0,1.3-0.1c0.4-0.1,0.8-0.2,1.2-0.3c0.3,0.2,0.7,0.3,1.1,0.4c0.3,0.1,0.6,0.1,0.9,0.1H27z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M31.5,20.9c1.1,0,1.9-0.1,2.6-0.5c0.4,0.2,0.9,0.4,1.4,0.4h0h0c0.1,0,0.2,0,0.2,0h0c0,0,0.1,0,0.1,0h0 c0,0,0.1,0,0.1,0H31.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M36,20.9c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0h0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0h0 c0.2,0.1,0.4,0.1,0.7,0.1L36,20.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M34.6,17.1C34.6,17.1,34.6,17.1,34.6,17.1c-0.5,0.4-0.9,0.9-1.4,1.2c-0.2,0.2-0.5,0.4-0.7,0.6 c0.2,0.2,0.4,0.5,0.6,0.7c0.3,0.3,0.7,0.6,1.1,0.8c0.1,0,0.2-0.1,0.3-0.1c0.4-0.2,0.8-0.6,1.1-1C35.2,18.7,34.9,17.9,34.6,17.1"
  })), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_107_",
    d: "M48.7,0h-2.2c-0.1,0-0.1,0-0.2,0l0,0c-0.1,0-0.1,0-0.2,0l0,0h0c-0.1,0-0.3,0-0.4,0l0,0 c-0.1,0.1-0.1,0.3-0.2,0.4l0,0c-2.2,4.7-4.6,8.8-6.9,12.1l0,0c-1.1,3.4-1.9,5.5-2.9,6.7l0,0c0.4,0.7,0.9,1.2,1.5,1.5l0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0.1,0,0.1,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0,0l0,0 c0,0,0.1,0,0.1,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0,0l0,0c0,0,0.1,0,0.1,0l0,0c0,0,0,0,0,0 l0,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0,0l0,0c0.1,0,0.2-0.1,0.2-0.1l0,0c0,0,0,0,0,0l0,0c0.1-0.1,0.2-0.1,0.4-0.2l0,0 C42.4,18,44.3,10.8,50.4,0l0,0H48.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_107_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st78"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 21.1799 21.1799 0 -1079.2273 -0.1147)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008DCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#0087C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6298,
    style: {
      stopColor: "#0078B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00508F"
    }
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: -13.2,
    y: -0.1,
    className: "st79",
    width: 63.5,
    height: 63.5
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_7_",
    filterUnits: "userSpaceOnUse",
    x: 14.4,
    y: -2.1,
    width: 10.1,
    height: 6.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend8 || (_feBlend8 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 14.4,
    y: -2.1,
    width: 10.1,
    height: 6.5,
    id: "SVGID_110_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_111_",
    x: 10.1,
    y: -0.3,
    width: 12.7,
    height: 2.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_112_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_111_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_113_",
    x: 10.1,
    y: -0.3,
    width: 12.7,
    height: 2.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_114_",
    className: "st81"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_113_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_115_",
    x: 10.1,
    y: -0.3,
    width: 12.7,
    height: 2.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_116_",
    className: "st82"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_115_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -2.9373 -2.9373 0 171.9459 2.5177)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3915,
    style: {
      stopColor: "#E3E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6745,
    style: {
      stopColor: "#C2C3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    style: {
      stopColor: "#949699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#939598"
    }
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -6.3,
    className: "st83",
    width: 12.7,
    height: 8.8
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st84"
  }, /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_118_",
    x: 14.8,
    y: 0.5,
    width: 9.2,
    height: 2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_119_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_118_",
    style: {
      overflow: "visible"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M15.3,0.5C15.3,0.5,15.3,0.5,15.3,0.5C15.3,0.5,15.3,0.5,15.3,0.5c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.2,0,0.2,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0 c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0 c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0.4,0.2,0.8,0.5,1.2,0.8c0.1-0.1,0.3-0.3,0.4-0.4c-0.8-0.6-1.7-0.9-2.7-0.9 C15.5,0.5,15.4,0.5,15.3,0.5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M17.9,1.7c0.2,0.2,0.4,0.4,0.6,0.7C18.8,2.3,19,2.2,19.2,2c-0.3-0.3-0.5-0.5-0.8-0.7 C18.2,1.5,18.1,1.6,17.9,1.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st87"
  }, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_120_",
    d: "M15.3,0.5c0.1,0,0.2,0,0.4,0c1,0,1.9,0.3,2.7,0.9c0.8-0.7,1.9-0.9,3.3-0.9h-6.9 C14.9,0.5,15.1,0.5,15.3,0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_121_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_120_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st88"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(4.8787 2.0235 2.0235 -4.8787 -91.3859 257.8317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CCFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1109,
    style: {
      stopColor: "#84CDEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2842,
    style: {
      stopColor: "#6EC9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4971,
    style: {
      stopColor: "#4AC2EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7033,
    style: {
      stopColor: "#20BAE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20BAE8"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "15.7,-2.1 21.9,0.4 20.5,3.6 14.4,1.1  "
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st87"
  }, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_123_",
    d: "M21.6,0.5c-1.4,0-2.4,0.2-3.3,0.9c0.3,0.2,0.6,0.4,0.8,0.7c1.2-0.7,2.3-1.2,3.5-1.5 c0.4-0.1,0.9-0.1,1.3-0.1H21.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_124_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_123_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st90"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(3.8531 -1.7468 -1.7468 -3.8531 111.2126 206.2813)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68C5EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3352,
    style: {
      stopColor: "#68C5EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3582,
    style: {
      stopColor: "#64C4EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6557,
    style: {
      stopColor: "#2EBAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8785,
    style: {
      stopColor: "#0DB4EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B2EA"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "17.7,0.9 29.3,-4.3 34.5,7.3 22.9,12.5  "
  })))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_8_",
    filterUnits: "userSpaceOnUse",
    x: 34.5,
    y: -0.1,
    width: 11.1,
    height: 17.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend9 || (_feBlend9 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 34.5,
    y: -0.1,
    width: 11.1,
    height: 17.1,
    id: "SVGID_126_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st92"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_127_",
    x: 24.5,
    y: 1.7,
    width: 30,
    height: 16.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_128_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_127_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_129_",
    x: 24.5,
    y: 1.7,
    width: 30,
    height: 16.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_130_",
    className: "st93"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_129_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_131_",
    x: 24.5,
    y: 1.7,
    width: 30,
    height: 16.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_132_",
    className: "st94"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 -16.4743 -16.4743 0 912.3121 18.1349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1531,
    style: {
      stopColor: "#464344"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#CAC9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: -31.3,
    className: "st95",
    width: 49.4,
    height: 49.4
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st96"
  }, /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_134_",
    x: 34.6,
    y: 0,
    width: 11,
    height: 17
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_135_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_134_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st97"
  }, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_136_",
    d: "M38.5,12.5c0.6-1.9,1.3-4.2,2.2-6.9c0.8-2.5,2.2-4.4,4.8-5.2c0.1-0.1,0.1-0.3,0.2-0.4 c-4.2,0.3-6.2,2.4-7.2,5.6c-1.7,5.6-2.8,9.2-3.8,11.5C35.9,15.8,37.2,14.3,38.5,12.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_137_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_136_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st98"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.9792,
    x2: 1,
    y2: 52.9792,
    gradientTransform: "matrix(0 20.7161 20.7161 0 -1057.5667 1.0025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A8E3"
    }
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: -16.7,
    y: -0.1,
    className: "st99",
    width: 62.1,
    height: 62.1
  }))))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M44.9,27.5L44.9,27.5c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3 c-0.1-0.1-0.3-0.1-0.4-0.1h-0.4v1.6h0.2v-0.7h0.1c0.1,0,0.2,0.1,0.3,0.3l0.2,0.4h0.3l-0.2-0.4C45.1,27.6,45,27.5,44.9,27.5z  M44.8,27.3h-0.2v-0.5h0.2c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.1,0.2C45.1,27.2,45,27.3,44.8,27.3z M44.8,26.2 c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.4,0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.3,0.9,0.3c0.4,0,0.6-0.1,0.9-0.4 c0.2-0.2,0.4-0.5,0.4-0.9c0-0.4-0.1-0.7-0.4-0.9C45.4,26.3,45.2,26.2,44.8,26.2z M45.6,28.2c-0.2,0.2-0.5,0.3-0.8,0.3 c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0.1,0.8,0.3 c0.2,0.2,0.3,0.5,0.3,0.8C45.9,27.7,45.8,28,45.6,28.2z M6.3,27.4c0-0.6,0-1,0-1.3h0c0.1,0.3,0.1,0.5,0.2,0.7l2.2,5h0.4l2.2-5 c0.1-0.1,0.1-0.3,0.2-0.6h0c0,0.5-0.1,0.9-0.1,1.3v4.4h0.8v-6.5h-1l-2,4.5c-0.1,0.2-0.2,0.4-0.3,0.8h0c0-0.2-0.1-0.4-0.3-0.8 l-2-4.6h-1v6.5h0.7V27.4z M14.2,25.9c0.1,0,0.3,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3C14.5,25,14.4,25,14.2,25 c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.3,0.1,0.4C14,25.9,14.1,25.9,14.2,25.9z M13.9,31.8h0.7v-4.7h-0.7V31.8z  M18,31.9c0.5,0,0.9-0.1,1.3-0.3v-0.7c-0.4,0.3-0.7,0.4-1.1,0.4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.4-0.7-0.4-1.3 c0-0.6,0.2-1,0.5-1.4c0.3-0.3,0.7-0.5,1.2-0.5c0.4,0,0.8,0.1,1.1,0.4v-0.8C19,27.1,18.6,27,18.2,27c-0.7,0-1.3,0.2-1.8,0.7 c-0.4,0.5-0.7,1.1-0.7,1.9c0,0.7,0.2,1.2,0.6,1.7C16.8,31.7,17.3,31.9,18,31.9z M21.7,27.3c-0.2,0.2-0.4,0.4-0.5,0.8h0v-1h-0.7v4.7 h0.7v-2.4c0-0.5,0.1-1,0.4-1.3c0.2-0.3,0.5-0.4,0.8-0.4c0.2,0,0.4,0,0.6,0.1v-0.8c-0.1,0-0.2-0.1-0.4-0.1 C22.1,27,21.9,27.1,21.7,27.3z M25.4,31.9c0.7,0,1.3-0.2,1.7-0.7c0.4-0.4,0.6-1,0.6-1.8c0-0.8-0.2-1.3-0.6-1.8 c-0.4-0.4-0.9-0.6-1.6-0.6c-0.7,0-1.3,0.2-1.7,0.6c-0.5,0.4-0.7,1.1-0.7,1.9c0,0.7,0.2,1.3,0.6,1.7C24.2,31.7,24.7,31.9,25.4,31.9z  M24.4,28.1c0.3-0.3,0.7-0.5,1.1-0.5c0.5,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.8,0.4,1.4c0,0.6-0.1,1-0.4,1.3c-0.3,0.3-0.6,0.5-1.1,0.5 c-0.5,0-0.9-0.2-1.1-0.5c-0.3-0.3-0.4-0.8-0.4-1.3C23.9,28.9,24.1,28.4,24.4,28.1z M31,31.5c0.3-0.3,0.4-0.6,0.4-0.9 c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.2-0.5-0.4-0.9-0.5c-0.4-0.2-0.6-0.3-0.7-0.4c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5 c0.1-0.1,0.3-0.2,0.6-0.2c0.4,0,0.8,0.1,1.1,0.3v-0.8c-0.3-0.1-0.6-0.2-1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.3,0.3-0.5,0.6-0.5,1 c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.4,0.8,0.5c0.4,0.2,0.6,0.3,0.8,0.4c0.1,0.1,0.2,0.3,0.2,0.5c0,0.4-0.3,0.7-0.9,0.7 c-0.4,0-0.8-0.1-1.2-0.4v0.8c0.3,0.2,0.7,0.3,1.2,0.3C30.3,31.9,30.7,31.8,31,31.5z M36.2,31.2c0.4-0.4,0.6-1,0.6-1.8 c0-0.8-0.2-1.3-0.6-1.8c-0.4-0.4-0.9-0.6-1.6-0.6c-0.7,0-1.3,0.2-1.7,0.6c-0.5,0.4-0.7,1.1-0.7,1.9c0,0.7,0.2,1.3,0.6,1.7 c0.4,0.4,1,0.7,1.7,0.7C35.2,31.9,35.7,31.7,36.2,31.2z M33,29.5c0-0.6,0.1-1.1,0.4-1.4c0.3-0.3,0.7-0.5,1.1-0.5 c0.5,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.8,0.4,1.4c0,0.6-0.1,1-0.4,1.3c-0.3,0.3-0.6,0.5-1.1,0.5c-0.5,0-0.9-0.2-1.1-0.5 C33.1,30.5,33,30,33,29.5z M38,31.8h0.7v-4h1.1v-0.6h-1.1v-0.7c0-0.7,0.3-1,0.8-1c0.2,0,0.3,0,0.5,0.1v-0.7 c-0.1-0.1-0.3-0.1-0.5-0.1c-0.4,0-0.7,0.1-1,0.4c-0.3,0.3-0.5,0.7-0.5,1.2v0.8h-0.8v0.6H38V31.8z M41.1,30.5c0,0.9,0.4,1.4,1.2,1.4 c0.3,0,0.5,0,0.7-0.2v-0.6c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.4-0.2-0.7v-2.6H43v-0.6h-1.2v-1.4 c-0.3,0.1-0.5,0.2-0.7,0.2v1.1h-0.8v0.6h0.8V30.5z M1.3,48.6c-0.4,0-0.7,0.1-0.9,0.4C0.1,49.3,0,49.6,0,50c0,0.4,0.1,0.7,0.4,0.9 c0.3,0.3,0.6,0.4,0.9,0.4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-0.9c0-0.4-0.1-0.7-0.4-1C2,48.8,1.7,48.6,1.3,48.6z M17.4,46 c0,1.2,0,2,0.1,2.5h0c-0.1-0.2-0.4-0.6-0.7-1.1L8.2,33.9H5.6v17.1h2V38.7c0-1.2,0-2-0.1-2.4h0.1c0.2,0.4,0.3,0.7,0.5,1.1l8.8,13.6 h2.4V33.9h-2V46z M25.2,43.3h6.2v-1.8h-6.2v-5.7h6.7v-1.8h-8.7v17.1h9.1v-1.8h-7.1V43.3z M34.1,35.8h4.9v15.3h2V35.8H46v-1.8H34.1 V35.8z M44,20.9h0.2v-1.5h0.5v-0.2h-1.2v0.2H44V20.9z M46.4,19.2l-0.5,1.2c0,0,0,0.1-0.1,0.2h0c0,0,0-0.1-0.1-0.2l-0.5-1.2h-0.3 v1.7h0.2v-1.1c0-0.2,0-0.3,0-0.3h0c0,0.1,0,0.1,0.1,0.2l0.6,1.3h0.1l0.6-1.3c0,0,0-0.1,0.1-0.2h0c0,0.1,0,0.2,0,0.3v1.1h0.2v-1.7 H46.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW1);
export default __webpack_public_path__ + "static/media/w1.0bf6da4781885ae7f51d26778798b64f.svg";
export { ForwardRef as ReactComponent };